export const LANDING_PAGE_URL = 'https://magicdispatch.com';
export const API_DOCS_URL = process.env.REACT_APP_API_DOCS_URL;
export const PLAY_STORE_URL =
  // 'https://play.google.com/store/apps/details?id=com.medsdriver&pcampaignid=web_share';
  'https://play.google.com/store/apps';
export const APP_STORE_URL =
  // 'https://apps.apple.com/us/app/meds-rx-driver/id1631950946';
  'https://apps.apple.com/us';
